import { render } from "./ScoreA.vue?vue&type=template&id=54191d58&scoped=true"
import script from "./ScoreA.vue?vue&type=script&lang=js"
export * from "./ScoreA.vue?vue&type=script&lang=js"

import "./ScoreA.vue?vue&type=style&index=0&id=54191d58&scoped=scoped&lang=less"
import "./ScoreA.vue?vue&type=style&index=1&id=54191d58&lang=css"

import exportComponent from "D:\\CODE\\clpgaAppDevnew\\clpga_html\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54191d58"]])

export default __exports__